import { CIcon } from '~/icons/types'

export const ciCarService: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23 20.027h-.457V3.473a.5.5 0 0 0-.5-.5h-1.912a.5.5 0 0 0-.5.5V13.8h-1.87v-.986a1.445 1.445 0 0 0 .957-1.354v-1.5a1.45 1.45 0 0 0-.429-1.025L16.755 7.41l-.742-2.936a1.45 1.45 0 0 0-1.412-1.1H9.4a1.451 1.451 0 0 0-1.412 1.1L7.245 7.41 5.71 8.93a1.46 1.46 0 0 0-.428 1.025v1.5a1.446 1.446 0 0 0 .957 1.354v.99h-1.87V3.474a.5.5 0 0 0-.5-.5H1.956a.5.5 0 0 0-.5.5v16.554H1a.5.5 0 1 0 0 1h3.826a.5.5 0 0 0 0-1h-.457V14.8h15.262v5.23h-.457a.5.5 0 1 0 0 1H23a.5.5 0 0 0 0-1v-.003Zm-19.631 0h-.913V3.973h.913v16.054Zm5.587-15.3a.455.455 0 0 1 .443-.34h5.2a.455.455 0 0 1 .443.34l.619 2.449H8.337l.619-2.45Zm-.8 9.078h-.917v-.891h.913l.004.89Zm6.7 0h-5.7V12.9h5.7v.905Zm1.913 0h-.913v-.891h.913v.89Zm.957-3.79h-1.9a.5.5 0 1 0 0 1h1.892v.45a.454.454 0 0 1-.457.447H6.739a.453.453 0 0 1-.457-.447v-.45h1.892a.5.5 0 0 0 0-1H6.282v-.058a.447.447 0 0 1 .132-.316L7.9 8.168h8.2l1.485 1.472a.447.447 0 0 1 .133.315l.008.06Zm3.825 10.017h-.912V3.972h.912v16.06Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'car-service',
  type: 'thin'
}
